import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { ReactComponent as CalendarIcon } from "./icons/calendar.svg";
import { ReactComponent as SettingsIcon } from "./icons/settings.svg";
import { ReactComponent as DealsIcon  } from "./icons/deals.svg";
import { ReactComponent as PlusIcon  } from "./icons/plus.svg";

import { ReactComponent as RubBtn } from '../header/currency.picker/icons/rub.svg';
import { ReactComponent as CnyBtn } from '../header/currency.picker/icons/cny.svg';
import { ReactComponent as UsdBtn } from '../header/currency.picker/icons/usd.svg';
import { ReactComponent as EurBtn } from '../header/currency.picker/icons/eur.svg';

import cssIf from '../../../scripts/helpers/class.add.if';
import { CURRENCY } from '../../../settings/constants';

import "./navbar.mobile.scss";
import PopupSettings from '../../popups/popup.settings';
import CurrencyPickerMobile from './currency.picker.mobile';
import useGlobal from "../../../store";

const NavbarMobile = () => {

  const [ globalState, globalActions ] = useGlobal();
  const { currency } = globalState;
  const { deals } = globalActions;

  const navigate = useNavigate();
  const location = useLocation();
  const popupSettings = PopupSettings();

  const [ isCurrencyPickerOpened, setCurrencyPickerOpened ] = useState( false );

  const currencyPicker = {

    open: () => setCurrencyPickerOpened( true ),
    close: () => setCurrencyPickerOpened( false ),
    toggle: () => setCurrencyPickerOpened( !isCurrencyPickerOpened ),

  }

  const currencyIcon = {

    [ CURRENCY.rub ]: <RubBtn />,
    [ CURRENCY.cny ]: <CnyBtn />,
    [ CURRENCY.usd ]: <UsdBtn />,
    [ CURRENCY.eur ]: <EurBtn />,

  }

  function handleAddDeal() {

    let timer = 0;

    if ( location.pathname.replace("/", "" ) !== "deals" ) { 
      
      timer = 100;       
      navigate("/deals"); 

    }

    setTimeout(() => {

      let c = document.querySelector('.orders-contanter');
      let a = document.getElementById('transaction_add_anchor');
      c?.scrollTo( 0, 0 );
      a?.scrollIntoViewIfNeeded();
      a?.click();

      let input = a.querySelector('input');
      input && input?.focus();

    }, timer );

  }

  return (

    <div className = "navbar_mobile space-between">

      <div className = "navbar_mobile__left flex flex-1 justify-around">
        
        <CurrencyPickerMobile

          opened = { isCurrencyPickerOpened }
          close = { currencyPicker.close }
          currency = { currency }
          changeCurrency = { deals.changeCurrency }

        />

        <NavbarMobileButton
          
          text = "настройки"
          action = { popupSettings.show }
          isActive = { false }
          icon = { <SettingsIcon /> }

        />

        <NavbarMobileButton
          
          text = "валюта"
          action = { currencyPicker.toggle }
          isActive = { false }
          icon = { currencyIcon?.[ currency ] }

        />

      </div>

      <div className = "navbar_mobile__center">
       
        <NavbarMobileButton
          
          text = "сделка"
          action = { handleAddDeal }
          icon = { <PlusIcon /> }

        />

      </div>

      <div className = "navbar_mobile__right flex flex-1 justify-around">

        <NavbarMobileButton
          
          text = "сделки"
          action = { () => navigate('/deals') }
          isActive = { false }
          icon = { <DealsIcon /> }

        />

        <NavbarMobileButton
          
          text = "история"
          action = { () => navigate('/history') }
          isActive = { false }
          icon = { <CalendarIcon /> }

        />

      </div>

    </div>

  );

}

const NavbarMobileButton = ({ text, icon, action, isActive = false }) => (

  <div 
    onClick = { action }
    className = {`navbar_mobile__btn ${ cssIf( isActive, 'navbar_mobile__btn--active') } flex flex-col justify-end items-center`}
  >

    { icon }
    <div className = "navbar_mobile__btn__text">{ text }</div>

  </div>

)

export default NavbarMobile;